// extracted by mini-css-extract-plugin
export default {"legend":"custom-legend_legend__FDAUq","legendItem":"custom-legend_legendItem__S8Law","legendSquare":"custom-legend_legendSquare__kR-YP"};